<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="600"
    @click:outside="closeForm()"
    scrollable
  >
    <template v-slot:activator="{ on }">
      <a v-on="on">{{ product.name }}</a>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ product.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-5">
        <div v-if="product.photos.length > 0" style="text-align:center;">
          <img :src="product.photos[0].mediumImageUrl" 
            style="max-width: 100%;"
          >
        </div>
        <p>
          <strong>Цена:</strong> {{ product.pricePerUnit }} &#8381; / {{ product.productUnitName }} 
          <template v-if="product.unitName != product.productUnitName">
            <br>
            <small>
              {{ (product.pricePerUnit / product.productUnitSize).toFixed(2) }} &#8381; / {{ product.unitName }}
            </small>
          </template>
        </p>
        <p v-if="product.unitName != product.productUnitName">
          <strong>Размер упаковки:</strong> {{ product.productUnitSize}} {{ product.unitName }}
        </p>
        <p v-if="product.brand">
          <strong>Производитель:</strong> {{ product.brand }}
        </p>
        <p v-if="product.description">
          <strong>Описание товара: </strong> {{ product.description }}
        </p>
      </v-card-text>
      <v-card-actions v-if="!hideSelect">
        
        <material-value :product="product" v-model="count" class="ml-3 mb-2"></material-value>
        <div class="pa-2">
          <strong>{{ (count * product.pricePerUnit).toFixed(0) }} &#8381;</strong>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save()"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MaterialValue from './ConstructorMaterialValue';

export default {
  props: {
    value: [String, Number],
    product: Object,
    hideSelect: {
      type: Boolean,
      default: false
    }
  },

  components: {
    MaterialValue
  },

  data() {
    return {
      activeMode: false,
      count: this.value
    }
  },

  watch: {
    ['value'](newVal) {
      this.count = newVal;
    }
  },

  methods: {
    closeForm() {
      this.count = this.value;
      this.activeMode = false;
    },
    save() {
      if (this.isInteger(this.count)) {
        this.$emit('input', this.count);
        this.$nextTick(() => this.closeForm());
      } else {
        this.$store.dispatch('showMessage', 'Кол-во должно быть целым числом.');
      }
    }
  }
}
</script>